import React, { useState, useEffect, useRef } from 'react';
import './navbarIndex.css';
import { Link, matchPath, useLocation, useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { setSettingFlag } from '../../C2wStore/actions';
import { COURSEDETAILS, OFFLINECOURSE } from '../../_utils/Routes';

function C2wNavbar({ pathLocation = null }) {

    const navigate = useNavigate(null)
    const dispatch = useDispatch()
    const settingFlag = useSelector((state) => state?.data?.settingFlag);
    const currentUser = useSelector((state) => state?.data?.currentUser);
    const [mobileTabFlag, setMobileTabFlag] = useState(false)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const mobNavBarTab = useRef(null);
    const location = useLocation()
    const match =
        matchPath({ path: `${COURSEDETAILS}/:id`, end: true }, location.pathname) ||
        matchPath({ path: `${OFFLINECOURSE}/:id`, end: true }, location.pathname);
    const hideNavbar = Boolean(match);

    /**
 * @hook useEffect - Window Resize Event Listener
 * @author Vishal Lohbande
 *
 * Description:
 * - Adds a window resize event listener to track changes in window width.
 * - Updates the `windowWidth` state whenever the window is resized.
 *
 * Behavior:
 * - `handleResize` callback updates the state with the current window width.
 * - Event listener is registered once on component mount and cleaned up on unmount.
 *
 * Usage:
 * - Useful for responsive UI adjustments based on window size.
 */
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    /**
     * @hook useEffect - Detect and handle clicks outside a referenced element
     * @author Vishal Lohbande
     *
     * Description:
     * - Adds a `mousedown` event listener to the document to detect clicks outside the `mobNavBarTab` element.
     * - If a click occurs outside the referenced mobile navbar tab, it sets `setMobileTabFlag` to false (typically to close/hide the tab).
     *
     * Behavior:
     * - Uses a ref `mobNavBarTab` to determine whether the click target is inside the component.
     * - Removes the event listener on component unmount to prevent memory leaks.
     *
     * Usage:
     * - Common pattern for closing dropdowns, modals, or menus when clicking outside their area.
     */
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (mobNavBarTab.current && !mobNavBarTab.current.contains(event.target)) {
                setMobileTabFlag(false);
            }

        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <>
        {windowWidth > 768 ? (
            <div className='C2wNavbar_ctn' style={{
                position: hideNavbar ? 'absolute' : 'fixed',
                width: hideNavbar === false ? '100%' : '100%'
            }}>
                <img src='/assets/images/landing/c2w-logo-full.svg' onClick={() => {
                    dispatch(setSettingFlag(false))
                    window.location.reload()
                    window.location.replace('/');
                }} alt='/' />
                <div className='C2wNavbarAnimation_tabs_btns'>
                    <div className='C2wNavbarAnimation_tabs'>
                        <Link to={'/courses'}>Courses</Link>
                        <Link to={'/superx'}>SuperX</Link>
                        <Link to={'/quizeethon-event'}>Quizeethon</Link>
                        <Link to={'/placements'}>Placements</Link>
                        <Link to={'/about-us'}>About us</Link>
                        <Link to={'/enquiry-form'}>Contact us</Link>
                    </div>
                    <div className='C2wNavbarAnimation_actions'>
                        {currentUser ? (
                            <div className="C2wProfile_nav">
                                <img src="/assets/images/landing/user.png" alt="Profile" className="C2wProfile_avatar" />
                                <span className="C2wProfile_name">{currentUser.name}</span>
                            </div>
                        ) : (
                            <>
                                <button className="C2wLogin_btn_nav" onClick={() => navigate('/login')}>Login</button>
                            </>
                        )}
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                                if (!settingFlag) {
                                    dispatch(setSettingFlag(true));
                                }
                            }}
                        >
                            <path d="M32.844 12.835L29.631 11.764L31.144 8.738C31.2974 8.42127 31.3487 8.06474 31.2908 7.71762C31.233 7.37049 31.0688 7.04987 30.821 6.8L27.2 3.179C26.9488 2.92755 26.6251 2.76116 26.2744 2.70322C25.9237 2.64528 25.5637 2.69871 25.245 2.856L22.219 4.369L21.148 1.15601C21.0349 0.821092 20.8202 0.529769 20.5338 0.322577C20.2474 0.115385 19.9035 0.00263104 19.55 5.66701e-06H14.45C14.0936 -0.000914308 13.7459 0.110198 13.4561 0.317637C13.1663 0.525076 12.949 0.81835 12.835 1.15601L11.764 4.369L8.738 2.856C8.42127 2.70263 8.06474 2.65133 7.71762 2.70919C7.37049 2.76704 7.04987 2.9312 6.8 3.179L3.179 6.8C2.92755 7.0512 2.76116 7.3749 2.70322 7.72558C2.64528 8.07625 2.69871 8.43627 2.856 8.755L4.369 11.781L1.15601 12.852C0.821092 12.9651 0.529769 13.1798 0.322577 13.4662C0.115385 13.7526 0.00263104 14.0965 5.66701e-06 14.45V19.55C-0.000914308 19.9064 0.110198 20.2541 0.317637 20.5439C0.525076 20.8337 0.81835 21.051 1.15601 21.165L4.369 22.236L2.856 25.262C2.70263 25.5787 2.65133 25.9353 2.70919 26.2824C2.76704 26.6295 2.9312 26.9501 3.179 27.2L6.8 30.821C7.0512 31.0725 7.3749 31.2388 7.72558 31.2968C8.07625 31.3547 8.43627 31.3013 8.755 31.144L11.781 29.631L12.852 32.844C12.966 33.1817 13.1833 33.4749 13.4731 33.6824C13.7629 33.8898 14.1106 34.0009 14.467 34H19.567C19.9234 34.0009 20.2711 33.8898 20.5609 33.6824C20.8507 33.4749 21.068 33.1817 21.182 32.844L22.253 29.631L25.279 31.144C25.5937 31.2935 25.9468 31.3427 26.2903 31.2849C26.6339 31.2272 26.9515 31.0652 27.2 30.821L30.821 27.2C31.0725 26.9488 31.2388 26.6251 31.2968 26.2744C31.3547 25.9237 31.3013 25.5637 31.144 25.245L29.631 22.219L32.844 21.148C33.1789 21.0349 33.4702 20.8202 33.6774 20.5338C33.8846 20.2474 33.9974 19.9035 34 19.55V14.45C34.0009 14.0936 33.8898 13.7459 33.6824 13.4561C33.4749 13.1663 33.1817 12.949 32.844 12.835ZM30.6 18.326L28.56 19.006C28.0909 19.1582 27.6605 19.4106 27.2987 19.7457C26.9369 20.0808 26.6523 20.4906 26.4647 20.9467C26.2771 21.4028 26.1909 21.8942 26.2122 22.3869C26.2335 22.8796 26.3617 23.3618 26.588 23.8L27.557 25.738L25.687 27.608L23.8 26.588C23.364 26.3708 22.8865 26.2498 22.3997 26.2332C21.9129 26.2166 21.4283 26.3048 20.9785 26.4918C20.5288 26.6788 20.1245 26.9602 19.793 27.317C19.4614 27.6738 19.2105 28.0977 19.057 28.56L18.377 30.6H15.674L14.994 28.56C14.8418 28.0909 14.5894 27.6605 14.2543 27.2987C13.9192 26.9369 13.5094 26.6523 13.0533 26.4647C12.5972 26.2771 12.1058 26.1909 11.6131 26.2122C11.1204 26.2335 10.6382 26.3617 10.2 26.588L8.262 27.557L6.392 25.687L7.412 23.8C7.63826 23.3618 7.76649 22.8796 7.78778 22.3869C7.80908 21.8942 7.72293 21.4028 7.53532 20.9467C7.34771 20.4906 7.06313 20.0808 6.70131 19.7457C6.3395 19.4106 5.90911 19.1582 5.44 19.006L3.4 18.326V15.674L5.44 14.994C5.90911 14.8418 6.3395 14.5894 6.70131 14.2543C7.06313 13.9192 7.34771 13.5094 7.53532 13.0533C7.72293 12.5972 7.80908 12.1058 7.78778 11.6131C7.76649 11.1204 7.63826 10.6382 7.412 10.2L6.443 8.313L8.313 6.443L10.2 7.412C10.6382 7.63826 11.1204 7.76649 11.6131 7.78778C12.1058 7.80908 12.5972 7.72293 13.0533 7.53532C13.5094 7.34771 13.9192 7.06313 14.2543 6.70131C14.5894 6.3395 14.8418 5.90911 14.994 5.44L15.674 3.4H18.326L19.006 5.44C19.1582 5.90911 19.4106 6.3395 19.7457 6.70131C20.0808 7.06313 20.4906 7.34771 20.9467 7.53532C21.4028 7.72293 21.8942 7.80908 22.3869 7.78778C22.8796 7.76649 23.3618 7.63826 23.8 7.412L25.738 6.443L27.608 8.313L26.588 10.2C26.3708 10.636 26.2498 11.1135 26.2332 11.6003C26.2166 12.0871 26.3048 12.5717 26.4918 13.0215C26.6788 13.4712 26.9602 13.8755 27.317 14.207C27.6738 14.5386 28.0977 14.7895 28.56 14.943L30.6 15.623V18.326ZM17 10.2C15.6551 10.2 14.3404 10.5988 13.2221 11.346C12.1039 12.0932 11.2323 13.1552 10.7176 14.3978C10.2029 15.6403 10.0683 17.0075 10.3307 18.3266C10.593 19.6457 11.2407 20.8573 12.1917 21.8083C13.1427 22.7593 14.3543 23.407 15.6734 23.6693C16.9925 23.9317 18.3597 23.7971 19.6022 23.2824C20.8448 22.7677 21.9068 21.8961 22.654 20.7779C23.4012 19.6596 23.8 18.3449 23.8 17C23.8 15.1965 23.0836 13.4669 21.8083 12.1917C20.5331 10.9164 18.8035 10.2 17 10.2ZM17 20.4C16.3275 20.4 15.6702 20.2006 15.1111 19.827C14.5519 19.4534 14.1161 18.9224 13.8588 18.3011C13.6015 17.6799 13.5341 16.9962 13.6653 16.3367C13.7965 15.6772 14.1203 15.0713 14.5958 14.5958C15.0713 14.1203 15.6772 13.7965 16.3367 13.6653C16.9962 13.5341 17.6799 13.6015 18.3011 13.8588C18.9224 14.1161 19.4534 14.5519 19.827 15.1111C20.2006 15.6702 20.4 16.3275 20.4 17C20.4 17.9017 20.0418 18.7665 19.4042 19.4042C18.7665 20.0418 17.9017 20.4 17 20.4Z" fill="#1675F2" />
                        </svg>
                    </div>
                </div>
            </div>
        ) : (
            <div className='C2wNavbarMobile_ctn'>
                <img src='/assets/images/landing/c2w-logo-full.svg' onClick={() => {
                    dispatch(setSettingFlag(false))
                    window.location.reload()
                    window.location.replace('/');
                   }}  alt='/'/>
                {mobileTabFlag === false ? (
                    <div > <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => { setMobileTabFlag(true) }}>
                         <path d="M1 2H19C19.2652 2 19.5196 1.89464 19.7071 1.70711C19.8946 1.51957 20 1.26522 20 1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2ZM19 14H1C0.734784 14 0.48043 14.1054 0.292893 14.2929C0.105357 14.4804 0 14.7348 0 15C0 15.2652 0.105357 15.5196 0.292893 15.7071C0.48043 15.8946 0.734784 16 1 16H19C19.2652 16 19.5196 15.8946 19.7071 15.7071C19.8946 15.5196 20 15.2652 20 15C20 14.7348 19.8946 14.4804 19.7071 14.2929C19.5196 14.1054 19.2652 14 19 14ZM19 7H1C0.734784 7 0.48043 7.10536 0.292893 7.29289C0.105357 7.48043 0 7.73478 0 8C0 8.26522 0.105357 8.51957 0.292893 8.70711C0.48043 8.89464 0.734784 9 1 9H19C19.2652 9 19.5196 8.89464 19.7071 8.70711C19.8946 8.51957 20 8.26522 20 8C20 7.73478 19.8946 7.48043 19.7071 7.29289C19.5196 7.10536 19.2652 7 19 7Z" fill="#1675F2" />
                    </svg></div>) : (
                    <div><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => { setMobileTabFlag(false) }}>
                        <path d="M18 6L6 18" stroke="#1675F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6 6L18 18" stroke="#1675F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></div>
                )
                }
                {mobileTabFlag && (
                    <>
                        <div 
                            className='C2wNavbarMobile_overlay' 
                            onClick={() => setMobileTabFlag(false)} 
                        />
                        <div className='C2wNavbarMobile_ctn_tabs' ref={mobNavBarTab}>
                            <Link
                                to={'/courses'}
                                onClick={() => setMobileTabFlag(false)}
                            >Courses</Link>
                            <Link
                                to={'/superx'}
                                onClick={() => setMobileTabFlag(false)}
                            >SuperX</Link>
                            <Link
                                to={'/quizeethon-event'}
                                onClick={() => setMobileTabFlag(false)}
                            >Quizeethon</Link>
                            <Link
                                to={'/placements'}
                                onClick={() => setMobileTabFlag(false)}
                            >Placements</Link>
                            <Link
                                to={'/about-us'}
                                onClick={() => setMobileTabFlag(false)}
                            >About us</Link>
                            <Link
                                to={'/enquiry-form'}
                                onClick={() => setMobileTabFlag(false)}
                            >Contact us</Link>
                            
                            <div className="C2wMobile_divider" />

                            {currentUser ? (
                                <div className="C2wMobile_user_profile">
                                    <img src="/assets/images/landing/user.png" alt="Profile" className="C2wMobile_user_avatar" />
                                    <span>{currentUser.name}</span>
                                </div>
                            ) : (
                                <div className="C2wMobile_auth_actions">
                                    <button className="C2wLogin_btn_nav C2wMobile_auth_btn" onClick={() => { navigate('/login'); setMobileTabFlag(false); }}>Login</button>
                                    <button className="C2wSignup_btn_nav C2wMobile_auth_btn" onClick={() => { navigate('/signup'); setMobileTabFlag(false); }}>Sign Up</button>
                                </div>
                            )}

                            <div className="C2wMobile_divider" />

                            <Link
                                to="/privacypolicy.html"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => setMobileTabFlag(false)}
                            >Privacy Policy</Link>
                            <Link
                                to={'/terms'}
                                rel="noopener noreferrer"
                                onClick={() => setMobileTabFlag(false)}
                            >Terms and Conditions</Link>
                            <Link
                                to={'/refund'}
                                rel="noopener noreferrer"
                                onClick={() => setMobileTabFlag(false)}
                            >Refund Policy</Link>
                        </div>
                    </>
                )}
            </div>
        )}
        </>
    )
}

export default C2wNavbar

